
import lodash from 'lodash';
window._ = lodash

import popper from "popper.js";
window.Popper = popper;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
//
//
//

// Declare Vue in the bootstrap file so we can make
// certain packages available to both the admin and the 'app' javascripts
// window.Vue = require('vue');

import Vue from 'vue';
import Paginate from 'vuejs-paginate';
import VeeValidate, { Validator } from 'vee-validate';


Vue.component('paginate', Paginate); //https://github.com/lokyoung/vuejs-paginate
Vue.use(VeeValidate); // https://github.com/baianat/vee-validate
Validator.localize(dictionary);

Vue.mixin({
    methods: {
    }
})

// Correct any field names etc here
const dictionary = {
    en: {
        messages: {
        },
        attributes: {
            first_name: 'first name',
            last_name: 'last name',
            phone_number: 'phone number',
            vehicle_reg: 'vehicle reg',
            theft_details: 'theft details',
            card_hashid: 'card',
            card_name: 'cardholder name',
            card_number: 'card number',
            card_expiry: 'expiry',
            card_cvc: 'cvc',
            register_password: 'password',
            register_confirm_password: 'password confirmation',
            login_password: 'password',
            ip_address: 'ip address',
        },
        custom: {
            register_confirm_password: {
                confirmed: () => 'Passwords do no match.',
            }
        }
    },
};
Validator.localize(dictionary);

Vue.mixin({
    methods: {
    }
})

let isInViewport = function (el) {
    let bounding = el.getBoundingClientRect();

    return bounding.top <= (window.innerHeight - 50) || bounding.top <= (document.documentElement.clientHeight - 50);
};


/**
 * Sets the navbar class.
 *
 * Used for minifying the top navbar on desktop-sm+ after user scrolls the page
 */
function setNavbarClass () {
    // This value is your scroll distance from the top
    var distanceFromTop = document.documentElement.scrollTop || document.body.scrollTop;
    var nav = document.getElementById('navbar-container');
    var formShowDistanceFromTop = 300;

    if (window.location.pathname != '/') {
        // If on sub page show form when scrolling starts
        formShowDistanceFromTop = 1;
    }

    if (!nav) {
        return;
    }

    // The user has scrolled to the tippy top of the page. Set appropriate style.
    if (distanceFromTop <= formShowDistanceFromTop) {
        nav.className = '';
    }

    // The user has scrolled down the page.
    if (distanceFromTop > formShowDistanceFromTop) {
        nav.className = 'minify-nav';
    }
};

window.addEventListener('scroll', function (evt) {
    setNavbarClass();

    // Slide in particular elements on scroll
    let slides = document.getElementsByClassName('slide-in-scroll unslid');

    Array.prototype.forEach.call(slides, function(slide, index) {
        if (isInViewport(slide)) {
            slide.classList.replace('unslid', 'slide-in-active');
        }
    });
});

window.addEventListener('load', function() {
    setNavbarClass();

    // Slide in particular elements on load
    let slidesOnLoad = document.getElementsByClassName('slide-in slide-in-load');

    Array.prototype.forEach.call(slidesOnLoad, function(slideOnLoad, index) {
        slideOnLoad.classList.add('slide-in-active');
    });
});
